<template>
  <div
    :class="classes"
    class="container"
  >
    <slot />
    <transition name="fade">
      <div class="grid-overlay">
        <svg
          v-if="editMode"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          :viewBox="viewBox"
          preserveAspectRatio="none"
        >
          <defs>
            <pattern
              id="grid"
              width="1"
              height="1"
              patternUnits="userSpaceOnUse"
            >
              <rect
                stroke-width="0.025"
                fill-opacity="0"
                x="0"
                y="0"
                width="1"
                height="1"
                :stroke="strokeColorSecondary"
              />
            </pattern>
            <pattern
              id="reference-lines"
              patternUnits="userSpaceOnUse"
              :width="columnWidth"
              :height="height"
            >
              <rect
                stroke-width="0.075"
                fill-opacity="0"
                x="0"
                y="0"
                :stroke="strokeColorPrimary"
                :width="columnWidth"
                :height="height"
              />
            </pattern>
          </defs>
          <rect
            fill="url(#grid)"
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
          <rect
            fill="url(#reference-lines)"
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
        </svg>
      </div>
    </transition>
    <transition name="fade">
      <keep-alive>
        <editor v-if="editMode" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import editorColors from '@/_uiColors.scss'
import GridEditor from '@/components/editor/GridEditor'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'grid',
  components: {
    editor: GridEditor
  },
  childOptions: {
    box: 'Box',
    flipBox: 'Flip-Box'
  },
  provide () {
    return {
      $grid: this
    }
  },
  props: {
    width: {
      type: Number,
      default: 192
    },
    height: {
      type: Number,
      default: 108
    },
    format: {
      type: String,
      default: 'landscape',
      validator: value => {
        return ['landscape', 'portrait'].includes(value)
      }
    }
  },
  data () {
    return {
      boxWidth: 1,
      boxHeight: 1
    }
  },
  computed: {
    columnWidth () {
      if (this.format === 'landscape') {
        // return 16 for a 12 column grid in landscape mode
        return 16
      } else {
        // return 18 for a 6 column grid in portrait mode
        // return 9 for a 12 column grid in portrait mode
        return 18
      }
    },
    viewBox () {
      return [0, 0, this.width, this.height].join(' ')
    },
    strokeColorPrimary () {
      return editorColors.colorGridPrimary
    },
    strokeColorSecondary () {
      return editorColors.colorGridSecondary
    },
    editMode () {
      return this.$root.$store.state.editMode
    },
    classes () {
      return {
        [this.format]: true
      }
    }
  },
  methods: {
    triggerClientSizeUpdate () {
      this.boxWidth = this.$el.clientWidth / this.width
      this.boxHeight = this.$el.clientHeight / this.height
    }
  },
  mounted () {
    this.triggerClientSizeUpdate()
  },
  activated () {
    this.triggerClientSizeUpdate()
  },
  created () {
    window.addEventListener('resize', this.triggerClientSizeUpdate)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.triggerClientSizeUpdate)
  }
}
</script>

<style lang="scss" scoped>

.container {
  position: absolute;
  width: 100%;
  height: 100%;

  .grid-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: visible;
    pointer-events: none;

    svg {
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }
}
</style>
